<template>
  <div class="search-goods">
    <!-- header -->
    <dg-header :showBack="true" title="商品搜索"></dg-header>
    <!-- 搜索框 -->
    <div class="search-input-head">
      <div class="input-box">
        <div class="search-btn"></div>
        <input class="search-input" type="text" v-model="params.comName" @blur="getSearch('str')" placeholder="搜索商品">
      </div>
    </div>
    <div class="search-wrap">
      <!-- 搜索结果 -->
      <div class="search-section">
        <van-list
                class="search-result-ul"
                v-model="loading"
                :finished="finished"
                :immediate-check="false"
                :finished-text="'没有更多了'"
                :offset="10"
                @load="onLoads"
                v-if="searchData.length > 0">
          <li class="search-result-item" v-for="(searchItem,index) in searchData" :key="index">
            <router-link replace :to="{path:'/product-detail',query:{id:searchItem._id}}">
              <!-- 商品图片 -->
              <span class="goods-pic dg-small-no-photo">
              <img :src="searchItem.comImage[0].url" alt v-if="searchItem.comImage.length > 0">
            </span>
              <!-- 商品信息价格，商品名 -->
              <div class="goods-dsc">
                <p class="goods-name">{{searchItem.comName}}</p>
                <p class="goods-price"><span>JPY </span>{{searchItem.price}}</p>
              </div>
              <!-- 加入购物车图标 -->
              <span class="car-icon"></span>
            </router-link>
          </li>
        </van-list>
        <div class="dg-no-search-data" v-if="flag"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import DgHeader from "@/components/header";
  import api from '@/server'

  export default {
    data() {
      return {
        // 列表数据
        searchData: [],
        // 是否还处于加载状态
        loading: false,
        // 判断是够数据滚动加载完毕
        finished: false,
        // 判断是否显示暂无数据
        flag: false,
        // 请求参数
        params: {
          comName: this.$route.params.str,
          pageSize: 10,
          pageNumber: 1
        }
      };
    },
    components: {
      DgHeader
    },
    created() {
      if (this.params.comName) {
        this.getSearch('')
      } else {
        this.flag = true
      }
    },
    methods: {
      // 根据关键字进行搜索
      getSearch(type) {
        if (!this.params.comName) {
          return false;
        }
        if (type === 'str') {
          this.params.pageNumber = 1;
          this.finished = false;
          this.searchData = [];
        }
        api.searchProduction(this.params).then(res => {
          let data = res.data.commondityList;
          if (type === 'scroll') {
            this.searchData = this.searchData.concat(data);
            this.loading = false;
            this.flag = false
          } else {
            if (res.code === 200 && data.length > 0) {
              this.searchData = data;
              this.totalPage = res.data.pageInfo.totalPageNumber;
              this.saveSearchStr();
               this.flag = false;
            } else {
              this.searchData = [];
              this.flag = true
            }
          }
        }).catch(err => {
          this.searchData = [];
          this.flag = true;
          console.log(err)
        });
      },
      // 将搜索成功过后的关键字保存到历史记录中去
      saveSearchStr() {
        let searchWord = localStorage.getItem('searchWord');
        if (searchWord == null) {
          localStorage.setItem('searchWord', this.params.comName);
          this.$store.dispatch('history', [this.params.comName]);
        } else {
          let arr = localStorage.getItem('searchWord');
          arr = arr.split(',');
          if (arr.indexOf(this.params.comName) === -1) {
            arr.unshift(this.params.comName);
          }
          let historyWord = arr;
          if (historyWord.length > 10) {
            historyWord.pop();
          }
          localStorage.setItem('searchWord', historyWord);
          this.$store.dispatch('history', historyWord);
        }
      },
      // 滚动加载
      onLoads() {
        this.params.pageNumber++;
        if (this.params.pageNumber > this.totalPage) {
          this.finished = true;
          this.loading = false;
        } else {
          console.log('sss')
          this.getSearch('scroll')
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .search-wrap {
    width: 100%;
    height: auto;
    padding: 0 30px;
    box-sizing: border-box;
    padding-top: 176px;
    // 搜索结果
    .search-section {
      .search-result-ul {
        width: 100%;
        height: auto;
        background: $bg02;
        border-radius: $br30;
        padding: 30px;
        box-sizing: border-box;
        box-shadow: $box-shadow3;

        .search-result-item {
          a {
            width: 100%;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
          }

          &:last-child {
            margin-bottom: 0;
          }

          // 商品图片
          .goods-pic {
            width: 150px;
            height: 160px;
            display: inline-block;
            border-radius: $br20;
            overflow: hidden;
            text-align: center;

            > img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              vertical-align: middle;
            }
          }

          .dg-no-photo {
            background: url("../../../assets/images/default-img.png") no-repeat 0 0/100%;
            border: 2px solid $bc04;
          }

          // 商品名，价格
          .goods-dsc {
            flex: 1;
            margin: 0 30px 0 20px;
            height: 160px;
            overflow: hidden;

            .goods-name {
              font-size: 28px;
              color: $fc06;
              @include ellipsis();
              margin-top: 16px;
            }

            .goods-price {
              margin: 20px 0 0;
              font-size: 30px;
              color: $fc04;

              span {
                font-size: 24px
              }
            }
          }

          // 加购图标
          .car-icon {
            width: 50px;
            height: 50px;
            display: inline-block;
            background: url("../../../assets/images/user-car-icon.png") no-repeat 0 0/100%;

            &:active {
              background: url("../../../assets/images/car-icon.png") no-repeat 0 0/100%;
            }
          }
        }
      }
    }
  }

  .search-input-head {
    width: 100%;
     max-width: 750px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    position: fixed;
    top: 88px;
    padding: 0 30px;
    background: $bg01;

    .input-box {
     
      display: flex;
      align-items: center;
      height: 68px;
      background: $bg02;
      padding: 0 30px;
      box-sizing: border-box;
      border-radius: $br40;
      flex: 1;
      box-shadow: $box-shadow3;

      .search-btn,
      .empty-input {
        width: 40px;
        height: 40px;
        display: inline-block;
      }

      .search-btn {
        background: url("../../../assets/images/search-icon.png") no-repeat 0 0/100%;
      }

      .empty-input {
        background: url("../../../assets/images/empty-close-icon.png") no-repeat 0 0/100%;
      }

      .search-input {
        flex: 1;
        margin: 0 24px;
        height: 100%;
        font-size: 28px;
        color: $fc03;
      }
    }

    .cancel-serach {
      font-size: 28px;
      color: $fc03;
      margin-left: 50px;
    }
  }
</style>

